import { core } from '@mockup/core.func';
import 'bootstrap/js/dist/collapse';

document.addEventListener('DOMContentLoaded', () => {
    core.init();
});
